import { render, staticRenderFns } from "./CustomerVoiceManagerShow.vue?vue&type=template&id=122b7119&"
import script from "./CustomerVoiceManagerShow.vue?vue&type=script&lang=js&"
export * from "./CustomerVoiceManagerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports